module.exports = __webpack_public_path__ + "static/media/carousel_onions_3.d82f3034.jpg";